// @flow
import React from 'react';

import type {BadgeShape as Badge} from '../Hit/Hit';

import './CancellationMessage.less';

type Props = {
    freeCancellationBadge: Badge,
    withIcon?: boolean
};

const CancellationMessage = ({freeCancellationBadge}: Props) => {
    return (
        freeCancellationBadge && (
            <div className="CancellationMessage">
                {freeCancellationBadge.helpText}
            </div>
        )
    );
};

export default CancellationMessage;
